import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
	faChartLine, 
	faClipboardList, 
	faFlask, 
	faCogs 
} from "@fortawesome/free-solid-svg-icons";

import "./styles/allProjects.css";

const AllProjects = () => {
	const navigate = useNavigate();

	const handleInquiry = (serviceName) => {
		navigate('/contact', { state: { selectedService: serviceName } });
	};

	return (
		<div className="all-projects-container">
			<div className="all-projects-project">
				<div className="project-container">
					<div className="project-header">
						<div className="project-icon">
							<FontAwesomeIcon icon={faChartLine} />
						</div>
						<div className="project-title">Statistical Analysis</div>
					</div>
					<div className="project-body">
						<div className="project-description">
							We help you navigate all aspects of statistical analysis, from hypothesis testing and p-values to checking assumptions, validating models, and performing power analysis. We ensure your results are robust and reliable.
						</div>
						<button 
							className="inquiry-btn"
							onClick={() => handleInquiry("Statistical Analysis")}
						>
							Inquire About This Service
						</button>
					</div>
				</div>
			</div>

			<div className="all-projects-project">
				<div className="project-container">
					<div className="project-header">
						<div className="project-icon">
							<FontAwesomeIcon icon={faClipboardList} />
						</div>
						<div className="project-title">Sampling & Survey Design</div>
					</div>
					<div className="project-body">
						<div className="project-description">
							Whether you need to design a new survey or refine an existing one, we minimize bias and maximize accuracy. We help craft surveys that generate trustworthy and actionable insights.
						</div>
						<button 
							className="inquiry-btn"
							onClick={() => handleInquiry("Sampling & Survey Design")}
						>
							Inquire About This Service
						</button>
					</div>
				</div>
			</div>

			<div className="all-projects-project">
				<div className="project-container">
					<div className="project-header">
						<div className="project-icon">
							<FontAwesomeIcon icon={faFlask} />
						</div>
						<div className="project-title">Experimental Design & A/B Testing</div>
					</div>
					<div className="project-body">
						<div className="project-description">
							We guide the planning, execution, and analysis of experiments to evaluate new initiatives or strategies. By designing rigorous tests and analyzing results, we help you make confident, data-driven decisions.
						</div>
						<button 
							className="inquiry-btn"
							onClick={() => handleInquiry("Experimental Design & A/B Testing")}
						>
							Inquire About This Service
						</button>
					</div>
				</div>
			</div>

			<div className="all-projects-project">
				<div className="project-container">
					<div className="project-header">
						<div className="project-icon">
							<FontAwesomeIcon icon={faCogs} />
						</div>
						<div className="project-title">Operations Research & Optimization</div>
					</div>
					<div className="project-body">
						<div className="project-description">
							Using your data, we build models and provide recommendations to help your business operate more efficiently, improve processes, and make better strategic decisions.
						</div>
						<button 
							className="inquiry-btn"
							onClick={() => handleInquiry("Operations Research & Optimization")}
						>
							Inquire About This Service
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AllProjects;